import React from "react";

import HeroDesktop from "../../images/hero/12Cuotas_Desktop.png";
import HeroMobile from "../../images/hero/12Cuotas_Mobile.jpg";
import HeroTablet from "../../images/hero/12Cuotas_Tablet.png";

export default class LandingBackground extends React.Component {
  state = {
    currentBackground: this.getBackgroundForCurrentDevice(),
  };

  componentDidMount() {
    // Escuchar cambios de tamaño de ventana
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    const newBackground = this.getBackgroundForCurrentDevice();
    if (newBackground !== this.state.currentBackground) {
      this.setState({ currentBackground: newBackground });
    }
  };

  getBackgroundForCurrentDevice() {
    const width = window.innerWidth;

    // Mobile: menor o igual a 600px
    if (width <= 600) {
      return HeroMobile;
    }
    // Tablet: entre 601px y 1200px
    else if (width <= 1200) {
      return HeroTablet;
    }
    // Desktop: mayor a 1200px
    else {
      return HeroDesktop;
    }
  }

  render() {
    return (
      <div
        className="home-background"
        style={{ backgroundImage: `url(${this.state.currentBackground})` }}
      />
    );
  }
}
